import { Api, DataResponse } from "imagine-essentials";
import { Address, Defect, DefectComment, DefectsFilter, Image } from "..";
import i18next from "i18next";

const addComment = async (comment: DefectComment) => {
  const result = await Api.post("api/comments/add", comment);
  const response: DataResponse<DefectComment> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const uploadImages = async (commentId: number, images: File[]) => {
  const formData = new FormData();
  formData.append("imageCount", images.length.toString());
  for (let i = 0; i < images.length; i++) {
    formData.append("image" + i, images[i]);
  }
  const result = await Api.postForm(
    "api/comments/images/" + commentId,
    formData
  );
  const response: DataResponse<void> = { success: result.success };
  if (result.success && result.data) {
    if (result.data.errors) {
      response.errorMessage = i18next.t("punchlist:imageUploadFailedCount", {
        count: result.data.errors,
      });
    }
  } else {
  }
  return response;
};

export const CommentsApi = {
  addComment,
  uploadImages,
};
